export const ko = {
    LEFT: '왼쪽:이동합니다.',
    RIGHT: '오른쪽으로 이동합니다.',
    DOWN: '다운로 이동:다음의 행이 있습니다.',
    UP: '다:이전 행이 있습니다. ',
    PGUP: 'PgUp:로 이동합니다. ',
    PGDOWN: 'PgDown:로 이동합니다. ',
    HOME: 'Home:이동하고 있습니다. ',
    END: 'End:로 이동합니다. ',
    ESC: 'Esc/오늘/Close:가깝습니다.',
    TITLE: '키보드의 지침'
};
